import { isMMP } from './consumer';
/**
 * 是否ios系统
 * @param ua
 * @returns
 */
export const isIOS = (ua) => /(iPhone|iPad|iPod|iOS)/i.test(ua);
/**
 * 是否Android系统
 * @param ua
 * @returns
 */
export const isAndroid = (ua) => /(Android)/i.test(ua);
const isTBS = (ua) => /TBS\/\d+/i.test(ua);
/**
 * qq移动浏览器
 */
export const isMQQB = (ua) => !isTBS(ua) && /MQQBrowser\/\d+/i.test(ua);
/**
 * qq 浏览器
 */
export const isQQB = (ua) => !isTBS(ua) && / QQBrowser\/\d+/i.test(ua);
/**
 * qq webview
 */
export const isMQQ = (ua) => !isTBS(ua) && /(QBWebViewType)/i.test(ua);
/**
 * 是否QQ浏览器
 * @param ua
 * @returns
 */
export const isQQ = (ua) => isMQQB(ua) || isQQB(ua) || isMQQ(ua);
/**
 * 是否微信
 * @param ua
 * @returns
 */
export const isWechat = (ua) => /(micromessenger)\/([\w\.]+)/i.test(ua);
/**
 * 是否微信小程序
 * @param ua
 * @returns
 */
export const isWXMiniProgram = (ua) => {
    // 因为 window 在 node 环境会报ReferenceError: window is not defined。因此进行try/catch处理
    try {
        // @ts-ignore
        return (!isMMP(ua) && /(micromessenger).*(miniprogram)/i.test(ua)) || ((window === null || window === void 0 ? void 0 : window.__wxjs_environment) === 'miniprogram');
    }
    catch (error) {
        return false;
    }
};
/**
 * 是否抖音
 * @param ua
 * @returns
 */
export const isDouYin = (ua) => /(aweme).*(ByteLocale)/i.test(ua);
/**
 * 是否华为、OPPO、VIVO、小米的快应用
 * @see https://km.sankuai.com/collabpage/1986616164
 * @param ua
 */
export const isQuickApp = (ua) => /hap\/[\d\.]+\/(huawei|vivo|oppo|xiaomi)/i.test(ua);
/**
 * 学习强国
 * @param ctx
 * @param next
 * @returns
 */
export const isXueXiQiangGuo = (ua) => /cn\.xuexi/i.test(ua);
/**
 * 是否支付宝
 * @param ua
 * @returns
 */
export const isAlipay = (ua) => ua.indexOf("alipayclient") > -1;
/**
 * 是否今日头条
 * @param param0
 * @param next
 * @returns
 */
export const isNewsArticle = (ua) => /NewsArticle/i.test(ua);
